import React, { useRef } from "react";
import { Icon } from "@components";
import { StyleSheet, TextInput, TouchableOpacity, View } from "react-native";
import { useTheme } from "@react-navigation/native";
import { Theme } from '@theme';
import { useScreen } from "@hooks";

export const EditInput = ({
    placeholder,
    value,
    onChangeText,
}: {
    placeholder: string;
    value: string;
    onChangeText: (text: string) => void;
}) => {

  const theme = useTheme();
  const {isAndroid} = useScreen()
  const styles = getStyle(theme);
  const inputRef = useRef<TextInput>(null);

  return (
    <View style={[styles.nameContainer, !isAndroid && {paddingVertical: theme.spacing.md}]}>
        <TextInput
            ref={inputRef}
            style={styles.nameInput}
            placeholder={placeholder}
            value={value}
            onChangeText={onChangeText}
            placeholderTextColor={theme.colors.greyBlue}
            autoCapitalize="none"
        />
        <TouchableOpacity onPress={() => inputRef.current?.focus()}>
          <Icon name="editPen" size={20} color={theme.colors.greyBlue} />
        </TouchableOpacity>
    </View>
  )
}

const getStyle = (theme: Theme) => {
    return StyleSheet.create({
        nameContainer: {
            flexDirection: 'row',
            alignItems: 'center',
            backgroundColor: theme.colors.white,
            borderRadius: 25,
            paddingHorizontal: 16,
            marginBottom: 16,
            borderWidth: 1,
            borderColor: theme.colors.lightGrey,
          },
          nameInput: {
            flex: 1,
            fontSize: 16,
            color: theme.colors.text,
          },
    })
}